import { createSlice } from "@reduxjs/toolkit";
import {
  createClaim,
  fetchClaims,
  fetchClaimById,
  updateClaim,
  updateClaimStatus,
  fetchClaimsByClient,
  fetchClaimByAppointment,
} from "../thunks/claimsThunk";

const initialState = {
  claims: [],
  currentClaim: null,
  clientClaims: [],
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 50,
    total: 0,
    pages: 0,
  },
};

const claimsSlice = createSlice({
  name: "claims",
  initialState,
  reducers: {
    clearCurrentClaim: (state) => {
      state.currentClaim = null;
    },
    clearClaimsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Create claim
      .addCase(createClaim.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createClaim.fulfilled, (state, action) => {
        state.loading = false;
        state.currentClaim = action.payload;
        state.claims.unshift(action.payload);
      })
      .addCase(createClaim.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch claims
      .addCase(fetchClaims.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClaims.fulfilled, (state, action) => {
        state.loading = false;
        state.claims = action.payload.claims;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchClaims.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch claim by ID
      .addCase(fetchClaimById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClaimById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentClaim = action.payload;
      })
      .addCase(fetchClaimById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update claim
      .addCase(updateClaim.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClaim.fulfilled, (state, action) => {
        state.loading = false;
        state.currentClaim = action.payload;
        state.claims = state.claims.map((claim) =>
          claim._id === action.payload._id ? action.payload : claim
        );
      })
      .addCase(updateClaim.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update claim status
      .addCase(updateClaimStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClaimStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.currentClaim = action.payload;
        state.claims = state.claims.map((claim) =>
          claim._id === action.payload._id ? action.payload : claim
        );
      })
      .addCase(updateClaimStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch claims by client
      .addCase(fetchClaimsByClient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClaimsByClient.fulfilled, (state, action) => {
        state.loading = false;
        state.clientClaims = action.payload;
      })
      .addCase(fetchClaimsByClient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch claim by appointment
      .addCase(fetchClaimByAppointment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClaimByAppointment.fulfilled, (state, action) => {
        state.loading = false;
        state.currentClaim = action.payload;
      })
      .addCase(fetchClaimByAppointment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCurrentClaim, clearClaimsError } = claimsSlice.actions;
export default claimsSlice.reducer;
